import { Link } from 'react-router-dom'
import { useState, useEffect } from 'react'

export default function Footer() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768)

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 768)
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [])

  return (
    <footer 
      id="footer_main" 
      role="contentinfo"
      style={{
        background: 'var(--color-accent-gray)',
        padding: '3rem 0 1.5rem',
        marginTop: '3rem',
        borderTop: '1px solid var(--color-stroke)',
        width: '100%',
        margin: 0,
        clear: 'both'
      }}
    >
      <div className="container" style={{
        maxWidth: 'var(--container-max-width)',
        margin: '0 auto',
        padding: '0 2rem'
      }}>
        {/* Footer Top */}
        <div className="footer-content" style={{
          display: 'grid',
          gridTemplateColumns: window.innerWidth < 768 ? '1fr' : '1.5fr 1fr 1fr 1fr',
          gap: '2.5rem',
          marginBottom: '2.5rem'
        }}>
          {/* Footer Brand */}
          <div className="footer-brand" style={{ maxWidth: '350px' }}>
            <h3 className="footer-logo" style={{
              fontFamily: 'var(--font-display)',
              fontSize: 'var(--font-size-h2)',
              fontWeight: 'var(--font-weight-bold)',
              letterSpacing: '0.04em',
              margin: '0 0 0.75rem 0',
              color: 'var(--color-text-primary)'
            }}>
              Plaza Aurora Outlet
            </h3>
            <p className="footer-tagline" style={{
              fontSize: 'var(--font-size-body)',
              color: 'var(--color-text-muted)',
              lineHeight: 'var(--line-height-relaxed)',
              margin: '0 0 0.75rem 0'
            }}>
              🛍️ El destino preferido para quienes buscan las mejores ofertas sin sacrificar calidad.
            </p>
            <p className="footer-address" style={{
              fontSize: 'var(--font-size-body)',
              color: 'var(--color-text-muted)',
              lineHeight: 'var(--line-height-relaxed)',
              margin: 0
            }}>
              📍 Av. Carlos Izaguirre 271-275 Independencia, Lima, Perú
            </p>
          </div>

          {/* Footer Links */}
          <div className="footer-column" style={{
            display: 'flex',
            flexDirection: 'column'
          }}>
            <h4 className="footer-title" style={{
              fontFamily: 'var(--font-ui)',
              fontSize: 'var(--font-size-small)',
              fontWeight: 'var(--font-weight-bold)',
              letterSpacing: '0.08em',
              margin: '0 0 1rem 0',
              color: 'var(--color-text-primary)'
            }}>
              EXPLORA
            </h4>
            <ul className="footer-links" style={{
              listStyle: 'none',
              padding: 0,
              margin: 0,
              display: 'flex',
              flexDirection: 'column',
              gap: '0.5rem'
            }}>
              <li><Link to="/" style={{
                fontSize: 'var(--font-size-body)',
                color: 'var(--color-text-muted)',
                transition: 'color 0.2s ease',
                lineHeight: 'var(--line-height-normal)',
                textDecoration: 'none'
              }}>Inicio</Link></li>
              <li><Link to="/descuentos" style={{
                fontSize: 'var(--font-size-body)',
                color: 'var(--color-text-muted)',
                transition: 'color 0.2s ease',
                lineHeight: 'var(--line-height-normal)',
                textDecoration: 'none'
              }}>Descuentos</Link></li>
              <li><Link to="/marcas" style={{
                fontSize: 'var(--font-size-body)',
                color: 'var(--color-text-muted)',
                transition: 'color 0.2s ease',
                lineHeight: 'var(--line-height-normal)',
                textDecoration: 'none'
              }}>Tiendas</Link></li>
              <li><Link to="/eventos" style={{
                fontSize: 'var(--font-size-body)',
                color: 'var(--color-text-muted)',
                transition: 'color 0.2s ease',
                lineHeight: 'var(--line-height-normal)',
                textDecoration: 'none'
              }}>Eventos</Link></li>
              <li><Link to="/ubicanos" style={{
                fontSize: 'var(--font-size-body)',
                color: 'var(--color-text-muted)',
                transition: 'color 0.2s ease',
                lineHeight: 'var(--line-height-normal)',
                textDecoration: 'none'
              }}>Ubícanos</Link></li>
            </ul>
          </div>

          {/* Column 2 - Compañía */}
          <div className="footer-column" style={{
            display: 'flex',
            flexDirection: 'column'
          }}>
            <h4 className="footer-title" style={{
              fontFamily: 'var(--font-ui)',
              fontSize: 'var(--font-size-small)',
              fontWeight: 'var(--font-weight-bold)',
              letterSpacing: '0.08em',
              margin: '0 0 1rem 0',
              color: 'var(--color-text-primary)'
            }}>
              COMPAÑÍA
            </h4>
            <ul className="footer-links" style={{
              listStyle: 'none',
              padding: 0,
              margin: 0,
              display: 'flex',
              flexDirection: 'column',
              gap: '0.5rem'
            }}>
              <li><Link to="/legal" style={{
                fontSize: 'var(--font-size-body)',
                color: 'var(--color-text-muted)',
                transition: 'color 0.2s ease',
                lineHeight: 'var(--line-height-normal)',
                textDecoration: 'none'
              }}>Política de Privacidad</Link></li>
              <li><Link to="/legal" style={{
                fontSize: 'var(--font-size-body)',
                color: 'var(--color-text-muted)',
                transition: 'color 0.2s ease',
                lineHeight: 'var(--line-height-normal)',
                textDecoration: 'none'
              }}>Política de Cookies</Link></li>
              <li><Link to="/legal" style={{
                fontSize: 'var(--font-size-body)',
                color: 'var(--color-text-muted)',
                transition: 'color 0.2s ease',
                lineHeight: 'var(--line-height-normal)',
                textDecoration: 'none'
              }}>Términos y Condiciones</Link></li>
              <li><Link to="/derechos-arco" style={{
                fontSize: 'var(--font-size-body)',
                color: 'var(--color-text-muted)',
                transition: 'color 0.2s ease',
                lineHeight: 'var(--line-height-normal)',
                textDecoration: 'none'
              }}>Derechos ARCO</Link></li>
              <li><Link to="/libro-reclamaciones" style={{
                display: 'inline-block',
                transition: 'opacity 0.2s ease',
                textDecoration: 'none'
              }}>
                <img 
                  src="https://ffbzkwlpbswgbngwvyvp.supabase.co/storage/v1/object/public/assets/logo/libro_reclamaciones.png" 
                  alt="Libro de Reclamaciones" 
                  style={{
                    height: '100px',
                    width: 'auto',
                    display: 'block'
                  }}
                />
              </Link></li>
            </ul>
          </div>

          {/* Column 3 - Contacto */}
          <div className="footer-column" style={{
            display: 'flex',
            flexDirection: 'column'
          }}>
            <h4 className="footer-title" style={{
              fontFamily: 'var(--font-ui)',
              fontSize: 'var(--font-size-small)',
              fontWeight: 'var(--font-weight-bold)',
              letterSpacing: '0.08em',
              margin: '0 0 1rem 0',
              color: 'var(--color-text-primary)'
            }}>
              CONTACTO
            </h4>
            <ul className="footer-links" style={{
              listStyle: 'none',
              padding: 0,
              margin: 0,
              display: 'flex',
              flexDirection: 'column',
              gap: '0.5rem'
            }}>
              <li><Link to="/contacto" style={{
                fontSize: 'var(--font-size-body)',
                color: 'var(--color-text-muted)',
                transition: 'color 0.2s ease',
                lineHeight: 'var(--line-height-normal)',
                textDecoration: 'none'
              }}>Tu marca en Plaza Aurora</Link></li>
              <li><Link to="/trabaja" style={{
                fontSize: 'var(--font-size-body)',
                color: 'var(--color-text-muted)',
                transition: 'color 0.2s ease',
                lineHeight: 'var(--line-height-normal)',
                textDecoration: 'none'
              }}>Trabaja con nosotros</Link></li>
              <li><Link to="/login" style={{
                fontSize: 'var(--font-size-body)',
                color: 'var(--color-text-muted)',
                transition: 'color 0.2s ease',
                lineHeight: 'var(--line-height-normal)',
                textDecoration: 'none'
              }}>Intranet</Link></li>
            </ul>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom" style={{
          display: 'flex',
          justifyContent: window.innerWidth < 768 ? 'center' : 'space-between',
          alignItems: 'center',
          paddingTop: '1.5rem',
          borderTop: '1px solid var(--color-stroke)',
          flexWrap: 'wrap',
          gap: '1rem',
          flexDirection: window.innerWidth < 768 ? 'column' : 'row'
        }}>
          <p className="footer-copyright" style={{
            fontSize: 'var(--font-size-small)',
            color: 'var(--color-text-muted)',
            margin: 0,
            textAlign: window.innerWidth < 768 ? 'center' : 'left'
          }}>
            © 2025 Plaza Aurora Outlet. Todos los derechos reservados.
            <br />
            <span style={{ fontSize: 'var(--font-size-micro)', marginTop: '0.25rem', display: 'inline-block' }}>
              This site is protected by reCAPTCHA and the Google{' '}
              <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--brand-blue)', textDecoration: 'none' }}>Privacy Policy</a> and{' '}
              <a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--brand-blue)', textDecoration: 'none' }}>Terms of Service</a> apply.
            </span>
          </p>

          {/* Social Links */}
          <div className="footer-social" style={{ display: 'flex', gap: '0.75rem' }}>
            <a 
              href="https://www.facebook.com/profile.php?id=61582145587744"
              aria-label="Facebook"
              className="social-link"
              style={{
                width: '36px',
                height: '36px',
                marginTop: '-1px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: 'var(--radius-sm)',
                color: 'var(--color-text-muted)',
                transition: 'all 0.2s ease',
                textDecoration: 'none'
              }}
              onMouseDown={(e) => {
                e.currentTarget.style.backgroundColor = 'var(--brand-blue-100)'
                e.currentTarget.style.transform = 'translateY(0)'
              }}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
              </svg>
            </a>
            <a 
              href="https://www.instagram.com/ccplazaaurora/" 
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="social-link"
              style={{
                width: '36px',
                height: '36px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: 'var(--radius-sm)',
                color: 'var(--color-text-muted)',
                transition: 'all 0.2s ease',
                textDecoration: 'none'
              }}
              onMouseDown={(e) => {
                e.currentTarget.style.backgroundColor = 'var(--brand-blue-100)'
                e.currentTarget.style.transform = 'translateY(0)'
              }}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
              </svg>
            </a>
            <a 
              href="https://www.tiktok.com/@ccplazaaurora" 
              target="_blank"
              rel="noopener noreferrer"
              aria-label="TikTok"
              className="social-link"
              style={{
                width: '36px',
                height: '36px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: 'var(--radius-sm)',
                color: 'var(--color-text-muted)',
                transition: 'all 0.2s ease',
                textDecoration: 'none'
              }}
              onMouseDown={(e) => {
                e.currentTarget.style.backgroundColor = 'var(--brand-blue-100)'
                e.currentTarget.style.transform = 'translateY(0)'
              }}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
              </svg>
            </a>
            <a 
              href="https://www.linkedin.com/" 
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
              className="social-link"
              style={{
                width: '36px',
                height: '36px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: 'var(--radius-sm)',
                color: 'var(--color-text-muted)',
                transition: 'all 0.2s ease',
                textDecoration: 'none'
              }}
              onMouseDown={(e) => {
                e.currentTarget.style.backgroundColor = 'var(--brand-blue-100)'
                e.currentTarget.style.transform = 'translateY(0)'
              }}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}


